module.exports = __webpack_public_path__ + "img/Fondo-faq-mobile.883f4b78.jpg";